import { getPositionName, getProjectName } from 'services/Utilities'

import { t } from 'translations'

// Parse the result to adocumentDefinition planned/worked start and end hours together.
export const parsePunchCards = punchCards =>
  punchCards.reduce((acc, line) => {
    line.name = `${line.lastName}, ${line.firstName} (${line.employeeNumber})`
    line.shift = `${line.shiftStart} - ${line.shiftEnd}`
    line.worked = `${line.workedStart || 'N/A'} - ${line.workedEnd || 'N/A'}`
    line.position = getPositionName(line.positionId, { canBeNull: true })
    line.project = getProjectName(line.project, { canBeNull: true })

    // Handle case where there are no punch rules on the shift
    if (line.flags && line.flags.missingPunchRules) {
      line.workedRounded = t('manager.punch.flags.MISSINGPUNCHRULES')
      line.difference = t('manager.punch.flags.MISSINGPUNCHRULES')
      line.workedTotal = t('manager.punch.flags.MISSINGPUNCHRULES')
      line.totalRegular = t('manager.punch.flags.MISSINGPUNCHRULES')
    } else {
      line.workedRounded = `${line.workedStartRounded || 'N/A'} - ${line.workedEndRounded || 'N/A'}`
    }

    if (!acc[line.userId]) acc[line.userId] = []
    acc[line.userId].push(line)
    return acc
  }, {})
